// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"baa89c4c","228":"0c8f05ac","606":"2c53fb71","911":"92f115bb","917":"ba6852f0"}[chunkId] + ".chunk.js";
};